export const customBrandOpts = {
    lojinha: {
        lojaanimale: { finalizar: () => undefined },
        lojafabula: { finalizar: () => undefined },
        lojafarm: { finalizar: () => undefined },
        lojaoffpremium: { finalizar: () => undefined },
        mariafilo: { finalizar: () => undefined },
        lojacrisbarros: {
            finalizar: (totalItems: number) => {
                const min = 4; const max = 18;
                if (totalItems < min || totalItems > max) return `A lojinha deve ter entre ${min} e ${max} produtos`
                else if (totalItems % 2 !== 0) return `A lojinha deve ter produtos em quantidade pares`
                else return undefined
            },
        },
        null: { finalizar: () => undefined },
    },
    createWishList: {
        lojaanimale: { nomeDaLojinha: () => undefined, linkDaLojinha: true, descricao: true, },
        lojafabula: { nomeDaLojinha: () => undefined, linkDaLojinha: true, descricao: true, },
        lojafarm: { nomeDaLojinha: () => undefined, linkDaLojinha: true, descricao: false, },
        lojaoffpremium: { nomeDaLojinha: () => undefined, linkDaLojinha: true, descricao: true, },
        mariafilo: { nomeDaLojinha: () => undefined, linkDaLojinha: true, descricao: true, },
        lojacrisbarros: {
            nomeDaLojinha: (user: string) => `Curadoria exclusiva por ${user}`,
            linkDaLojinha: false,
            descricao: true,
        },
        null: { nomeDaLojinha: () => undefined, linkDaLojinha: false, descricao: false, },
    },
    EditWishList: {
        lojaanimale: { nomeDaLojinha: () => true, linkDaLojinha: true, descricao: true, },
        lojafabula: { nomeDaLojinha: () => true, linkDaLojinha: true, descricao: true, },
        lojafarm: { nomeDaLojinha: () => true, linkDaLojinha: true, descricao: false, },
        lojaoffpremium: { nomeDaLojinha: () => true, linkDaLojinha: true, descricao: true, },
        mariafilo: { nomeDaLojinha: () => true, linkDaLojinha: true, descricao: true, },
        lojacrisbarros: { nomeDaLojinha: () => false, linkDaLojinha: false, descricao: true, },
        null: { nomeDaLojinha: () => false, linkDaLojinha: false, descricao: false, },
    },
};
